import React, { useEffect, useState, useMemo } from "react";

import styled from "styled-components";
import Button from "sushiweb/Button";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useHistory } from "react-router-dom";

import variables from "../../../constants/assets/variables";
import FileUpload from "../../Common/FileUpload";
import NoFooterModal from "../../Common/NoFooterModal";
import * as BulkUpdateTdsPropertiesActions from "../../../store/actions/BulkUpdateTdsProperties";
import * as UserActions from "../../../store/actions/User";
import Errors from "../../../constants/Errors.json";
import PaginatedReactDropdown from "../../Common/PaginatedReactDropdown";
import InformationBar from "../../Common/InformationBar";
import {
  BottomSectionModal,
  Link,
  UploadCsvOption,
  NotesSection,
} from "../../../constants/assets/containers";

const instructions = [
  "Please provide data as per the format in the sample file.",
  "Please try to open your sample csv file always with MS excel or google sheets but don't open with other editors.",
];

const FileUploadModal = (props) => {
  const history = useHistory();
  const [activeFile, setActiveFile] = useState("");
  const [callback_key, setCallback_key] = useState("");
  const [presign_url, setPresign_url] = useState("");
  const [csv_type, setCsv_type] = useState("");
  const [sample_download_url, setSampleDownloadUrl] = useState("");
  const filterTypes = [
    "SPECIFIED_PERSON",
    "PAN_AADHAAR_LINKED_STATUS",
    "PAN_NO",
  ];

  const handleClose = () => {
    history.push("/");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    props
      .getUploadUrl({
        filename: "bulk_upload_driver_asset",
        csv_type: csv_type,
      })
      .then((res) => {
        if (res) {
          setCallback_key(res.callback_key);
          setPresign_url(res.file_upload_url);
          setCsv_type(res.csv_type);
        } else {
          props.setStatus({ type: "error", message: Errors.GENERAL_ERROR });
        }
      });
  };

  const extraParamsAckObj = useMemo(() => {
      return { presign_url: presign_url}
    }, [presign_url]);

  const handleChange = (key, val) => {
    setCsv_type(val);
    if (val === "") {
      setSampleDownloadUrl("");
      return;
    }

    if (val === "PAN_AADHAAR_LINKED_STATUS") {
      const download_url = `${
        process.env.REACT_APP_API_URL
          ? `${process.env.REACT_APP_API_URL.replace(
              variables.routeEndpoint,
              variables.sampleFileEndPoint
            )}/sample/update_pan_aadhaar_status.csv`
          : ""
      }`;
      setSampleDownloadUrl(download_url);
    } else if (val === "SPECIFIED_PERSON") {
      const download_url = `${
        process.env.REACT_APP_API_URL
          ? `${process.env.REACT_APP_API_URL.replace(
              variables.routeEndpoint,
              variables.sampleFileEndPoint
            )}/sample/update_tds_properties.csv`
          : ""
      }`;
      setSampleDownloadUrl(download_url);
    } else {
      const download_url = `${
        process.env.REACT_APP_API_URL
          ? `${process.env.REACT_APP_API_URL.replace(
              variables.routeEndpoint,
              variables.sampleFileEndPoint
            )}/sample/update_pan_no.csv`
          : ""
      }`;
      setSampleDownloadUrl(download_url);
    }
  };

  const CheckIfButtonDisabled = () => {
    return activeFile === "" || csv_type === "";
  };

  return (
    <BulkUpdateTdsPropertiesModal>
      <NoFooterModal
        header
        heading="Bulk Update TDS Properties"
        handleClose={handleClose}
        id="bulkUpdateTdsPropertiesModal"
        modalButtons={
          <BottomSectionModal>
            <Button
              data-testid="assignCourse"
              disabled={CheckIfButtonDisabled()}
              onClick={handleSubmit}
              className="sushi-btn"
            >
              Confirm
            </Button>
          </BottomSectionModal>
        }
      >
        <PaginatedReactDropdown
          options={filterTypes}
          handleChange={handleChange}
          keyToChange="csv_type"
          placeholder="CSV Type"
          showCross={true}
          id="fileTypeDropdown"
          showPagination={false}
          value={csv_type}
        />
        <UploadCsvOption>
          <FileUpload
            title="CSV file"
            uploadUrl="/driver-accounting/bulk-update-tds-properties"
            extraParamsAckObj={extraParamsAckObj}
            callback_key={callback_key}
            presign_url={presign_url}
            handleClose={handleClose}
            keyName="callback_key"
            activeFile={activeFile}
            setActiveFile={setActiveFile}
            acceptTypes=".csv, .xls, .xlsx"
          />
        </UploadCsvOption>
        <NotesSection>
          <InformationBar
            sampleUrl={sample_download_url}
            instructions={instructions}
          />
        </NotesSection>
      </NoFooterModal>
    </BulkUpdateTdsPropertiesModal>
  );
};

const BulkUpdateTdsPropertiesModal = styled.section``;

function mapDispatchToProps(dispatch) {
  return {
    getUploadUrl: bindActionCreators(
      BulkUpdateTdsPropertiesActions.getUploadUrl,
      dispatch
    ),
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
  };
}

export default connect(null, mapDispatchToProps)(FileUploadModal);
